/* eslint-disable react/destructuring-assignment */
import React, { SVGProps } from 'react';

const NewPlayIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    (<svg
      className={props.className}
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-palette="NewPlayIcon">
      <rect width="30" height="30" rx="15" fill="#F6A609" fillOpacity="0.15" />
      <path
        d="M7.5 8.99505C7.5 8.58357 7.84148 8.25 8.24385 8.25H21.7561C22.167 8.25 22.5 8.58371 22.5 8.99505V21.0049C22.5 21.4164 22.1585 21.75 21.7561 21.75H8.24385C7.83304 21.75 7.5 21.4163 7.5 21.0049V8.99505ZM9 9.75V20.25H21V9.75H9ZM13.9664 12.3109L17.6256 14.7504C17.7634 14.8423 17.8007 15.0286 17.7088 15.1664C17.6868 15.1993 17.6585 15.2276 17.6256 15.2496L13.9664 17.689C13.8286 17.781 13.6423 17.7437 13.5504 17.6059C13.5175 17.5566 13.5 17.4987 13.5 17.4394V12.5606C13.5 12.3949 13.6343 12.2606 13.8 12.2606C13.8592 12.2606 13.9171 12.2781 13.9664 12.3109Z"
        fill="#F6A609"
      />
    </svg>)
  );
};

export default NewPlayIcon;
